var _RootObservableClass_procedure;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { IList, MutableSet } from '@noshiro/ts-utils';
import { binarySearch, issueToken } from '../utils';
import { ObservableBaseClass } from './observable-base-class';
export class RootObservableClass extends ObservableBaseClass {
    constructor({ type, currentValueInit, }) {
        super({
            kind: 'root',
            type,
            depth: 0,
            currentValueInit,
        });
        _RootObservableClass_procedure.set(this, void 0);
        this.type = type;
        __classPrivateFieldSet(this, _RootObservableClass_procedure, [], "f");
        this._descendantsIdSet = new MutableSet();
    }
    addDescendant(child) {
        if (this._descendantsIdSet.has(child.id))
            return;
        this._descendantsIdSet.add(child.id);
        const insertPos = binarySearch(__classPrivateFieldGet(this, _RootObservableClass_procedure, "f").map((a) => a.depth), child.depth);
        __classPrivateFieldSet(this, _RootObservableClass_procedure, IList.insert(__classPrivateFieldGet(this, _RootObservableClass_procedure, "f"), insertPos, child), "f");
    }
    startUpdate(nextValue) {
        const token = issueToken();
        this.setNext(nextValue, token);
        for (const p of __classPrivateFieldGet(this, _RootObservableClass_procedure, "f")) {
            p.tryUpdate(token);
        }
    }
}
_RootObservableClass_procedure = new WeakMap();
